import { DateRangePicker, type DateRangePickerProps } from '@shared/ui/date-range-picker';

import { CollapseFilter } from '../collapse-filter';

type DateRangeFilterProps = DateRangePickerProps & {
  title: string;
};

export const DateRangeFilter = (props: DateRangeFilterProps) => {
  const { title, value, onChange, helperText } = props;

  return (
    <CollapseFilter title={title}>
      <DateRangePicker value={value} onChange={onChange} helperText={helperText} />
    </CollapseFilter>
  );
};
